import { useRef, useState } from "react";

import { getErrorMessage } from "@/utils/errorHandling";

/** Own one complete draft/lifecycle operation, including its save and refresh. */
export function useGrowthFormMutationState() {
  const running = useRef(false);
  const [pendingLabel, setPendingLabel] = useState<string | null>(null);

  const run = async (
    label: string,
    action: () => Promise<void>,
    fallback: string,
    onError: (message: string | null) => void,
  ) => {
    if (running.current) return;
    running.current = true;
    setPendingLabel(label);
    onError(null);
    try {
      await action();
    } catch (error: unknown) {
      onError(getErrorMessage(error, fallback));
    } finally {
      running.current = false;
      setPendingLabel(null);
    }
  };

  return { pendingLabel, busy: pendingLabel !== null, run };
}
